module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#bundle",
      toString: function () {
        return this.url;
      }
    }